import { useState, useCallback } from "react";
import { leadTimeDashboardApi } from "../api/leadTimeDashboardApi";

export const useLeadTimeStats = (fileType = 'main', objectType) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);

  const fetchStats = useCallback(async () => {
    if (!objectType) {
      setError("Please select an object type");
      return;
    }

    setLoading(true);
    setError(null);
    setStats(null);
    setHasFetched(true);

    try {
      const response = await leadTimeDashboardApi.getLeadTimeDashboard(fileType, objectType);
      if (response?.statistics && response.lead_times !== undefined) {
        setStats({
          average: response.statistics?.average ?? null,
          min: response.statistics?.min ?? null,
          max: response.statistics?.max ?? null,
          count: response.lead_times?.length ?? 0,
        });
      } else {
        console.error("Invalid data from getLeadTimeDashboard:", response);
        throw new Error("Invalid data format from API.");
      }
    } catch (err) {
      console.error(
        "Error loading dashboard data:",
        err.response || err.message || err
      );
      setError(err.message || "Failed to load dashboard data.");
    } finally {
      setLoading(false);
    }
  }, [fileType, objectType]);

  return { stats, loading, error, hasFetched, fetchStats };
};
